import React, { Component, PropTypes } from 'react';
import pick from 'lodash/pick';
import { SubmissionError } from 'redux-form';
import BillingForm from 'account/components/billing_form';
import PaymentMethod from 'common/containers/payment_method';
import PaymentHistory from 'account/components/payment_history';
import { Meta } from 'common/components/meta';


/**
 * Client's billing address, payment method and invoices.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Billing extends Component {
  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchCountriesIfNeeded()
    this.props.fetchInvoicesIfNeeded()
  }

  handleSubmit(formData) {
    const { user, updateUserRequest, updateUserLocal } = this.props

    const data = pick(formData,
      ['lead_source', 'billing_name', 'billing_address_line_1', 'billing_address_line_2',
       'billing_city', 'billing_state', 'billing_postal_code', 'billing_country']
    )

    return updateUserRequest(user.id, data)
      .then((res) => updateUserLocal(res.data))
      .catch((res) => {
        /* field-specific errors */
        const data = res.data;
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) throw new SubmissionError({ [field]: data[field][0] });
          }
        }
        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      });
  }

  render() {
    const { user, countries, invoices } = this.props

    return (
      <div id="content" className="l-content billing">
        <Meta title="Billing Information" />
        <div className="row">
          <div className="columns small-16">
            <fieldset>
              <h3 className="section-header">Billing Info</h3>

              <div className="row columns medium-12">
                <BillingForm onSubmit={this.handleSubmit} initialValues={{...user}}
                  countries={countries}/>
              </div>
            </fieldset>

            <fieldset>
              <h3 className="section-header">Payment Method</h3>

              <div className="row columns medium-6">
                <PaymentMethod />
              </div>
            </fieldset>

            <fieldset>
              <h3 className="section-header">Payment History</h3>

              <PaymentHistory invoices={invoices}/>
            </fieldset>
          </div>
        </div>
      </div>)
  }
}

/**
 * PropTypes.
 *
 * @property {func} fetchCountriesIfNeeded - fetch countries if needed
 * @property {func} fetchInvoicesIfNeeded - fetch invoices if needed
 * @property {func} updateUserRequest - request to update user
 * @property {func} updateUserLocal - update user locally
 * @property {obj} user - logged in user profile data
 * @property {array} countries - list of country choices
 * @property {array} invoices - list of invoices
 */
Billing.propTypes = {
  fetchCountriesIfNeeded: PropTypes.func,
  fetchInvoicesIfNeeded: PropTypes.func,
  updateUserRequest: PropTypes.func,
  updateUserLocal: PropTypes.func,
  user: PropTypes.object,
  countries: PropTypes.array,
  invoices: PropTypes.array,
};



// WEBPACK FOOTER //
// ./account/components/billing.jsx